import React from 'react';
import OrgBrandingCard from './OrgBrandingCard';
import './OrganizationSettingsPage.css';

/**
 * Superadmin-only org-wide configuration (not location admin Settings).
 */
export default function OrganizationSettingsPage({ token, user }) {
  if (!user || user.role !== 'superadmin') {
    return (
      <div className="organization-settings-page">
        <div className="organization-settings-denied">
          <h1>Access denied</h1>
          <p>Organization settings are available to superadmin only.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="organization-settings-page">
      <div className="organization-settings-header">
        <h1>🎨 Organization</h1>
        <p>
          Hospital-wide identity and appearance. The same branding is used on login, public pages,
          guest device scans, and the app (navigation, headers, and primary buttons).
        </p>
      </div>

      <section className="organization-settings-section">
        <h2>Branding</h2>
        <p className="organization-settings-section-desc">
          Chrome is the frame (login panel, sidebar, header). Accent is actions (buttons, links,
          active navigation). Staff can still pick their own page backdrop in Preferences.
        </p>
        <OrgBrandingCard token={token} />
      </section>
    </div>
  );
}
